<template>
    <svg width="1.125em" height="1.125em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.3" d="M15 11V4H4V12.17L4.59 11.59L5.17 11H6H15Z" fill="currentColor"/>
        <path d="M21 6H19V15H6V17C6 17.55 6.45 18 7 18H18L22 22V7C22 6.45 21.55 6 21 6ZM16 13C16.55 13 17 12.55 17 12V3C17 2.45 16.55 2 16 2H3C2.45 2 2 2.45 2 3V17L6 13H16ZM4.59 11.59L4 12.17V4H15V11H5.17L4.59 11.59Z" fill="currentColor"/>
    </svg>
</template>
